import type { DisciplineInfo } from '@brighterly/lib-core-types/discipline/interfaces'
import type { ScopeMode } from '@utils/stores/scoped-entry'

import { useDisciplineStore } from '@stores/discipline'

import { useCsRoutes } from '@composables/routes/cs-route.hook'

interface ActiveDisciplineInfoApiPayload {
  disciplineId: number
  mode: ScopeMode
}

interface ActiveDisciplineInfoApiOptions {
  onStart?: () => void
  onSuccess?: (disciplineInfo: DisciplineInfo) => void
  onError?: (err: unknown) => void
  onFinish?: () => void
}

export const useActiveDisciplineInfoApi = async (
  payload: ActiveDisciplineInfoApiPayload,
  options?: ActiveDisciplineInfoApiOptions,
): Promise<DisciplineInfo | null> => {
  const { $axios } = useNuxtApp()

  const disciplineStore = useDisciplineStore()

  const url = useCsRoutes('discipline', {
    '[discipline_id]': payload.disciplineId,
  })

  options?.onStart?.()

  const requestId = disciplineStore.beginInfo(payload.disciplineId, payload.mode)

  return $axios.get(url!)
    .then(({ data }) => {
      const disciplineInfo = data.data as DisciplineInfo

      disciplineStore.settleInfo(payload.disciplineId, requestId, disciplineInfo)
      options?.onSuccess?.(disciplineInfo)

      return disciplineInfo
    })
    .catch((err) => {
      console.error(err)
      disciplineStore.failInfo(payload.disciplineId, requestId)
      options?.onError?.(err)

      return null
    })
    .finally(() => {
      options?.onFinish?.()
    })
}
